import React from 'react';
import classNames from 'classnames';
import { Panel, Row, Col } from 'react-bootstrap';
import ArrowButton from '../../../common/button-arrow';

const ProductItem = ({ item, status, image, categoryName, deleteDisabled, editDisabled, itemType, ...props }) => {
  let statusClass = classNames('product-status', (status ? status.toLowerCase() : ''));

  return (
    <Panel className="product-item">
      <Row>
        <Col md={8}>
          {image && <img src={image} className="imgPreview"/>}
          {(status === 'INACTIVE' || status === 'DRAFT') && <span className={statusClass}>{status}</span>}
          {item.name || item.attributes.name}
          {
            categoryName && <span className="category-name">Category: <span>{categoryName}</span></span>
          }
          {
            categoryName && status === 'INACTIVE' && <span className={statusClass}>{status}</span>
          }
        </Col>
        <Col md={4}>
          <ArrowButton submit={false}
                       arrow={false}
                       onClick={() => props.onDelete(item.id)}
                       disabled={!!deleteDisabled}
                       permissions={{
                         action:       'destroy',
                         subjectClass: itemType
                       }}
                       className="pull-right">Delete</ArrowButton>
          <ArrowButton submit={false}
                       arrow={false}
                       onClick={() => props.onEdit(item.id)}
                       disabled={!!editDisabled}
                       permissions={{
                         action:       'update',
                         subjectClass: itemType
                       }}
                       color="grey"
                       className="pull-right">Edit</ArrowButton>
        </Col>
      </Row>
    </Panel>
  )
};

export default ProductItem;



// WEBPACK FOOTER //
// ./src/components/admin/products/common/product-item.jsx